import "swiper";
import Cash from "cash-dom";
import { mergeSettings } from "./Functions";
import { type } from "./Type";

function doesInclude(test, value) {
    if (!test) {
        return null;
    }
    return !!~test.indexOf(value);
}

function startWith(test, value) {
    if (!test) {
        return null;
    }
    return test.indexOf(value) === 0;
}

function camelCase(string) {
    return (string || "").replace(/(\-[a-z])/g, function(match) {
        return match.toUpperCase().replace(/-/, "");
    });
}

function evil(fn) {
    return new Function("return " + fn)();
}

function convertFromString(variable) {
    if (getType(variable) === "string") {
        try {
            variable = evil(variable);
        } catch (e) {
        } finally {
            return getType(variable) === "string"
                ? camelCase(variable)
                : variable;
        }
    } else {
        return variable;
    }
}

function checkNaN(variable, type) {
    if (!variable) {
        return null;
    }

    if (!type) {
        type = (typeof variable).toLowerCase();
    }

    return type == "number" && isNaN(variable);
}

const POSSIBLE_TYPES = "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
    " "
);

function getType(variable) {
    const TYPE = (typeof variable).toLowerCase();

    if (variable == null || checkNaN(variable, TYPE)) {
        return String(variable);
    } else if (TYPE === "object" || TYPE === "function") {
        let constructorType = variable.constructor.toString();
        for (let index in POSSIBLE_TYPES) {
            let possibleType = POSSIBLE_TYPES[index];
            if (doesInclude(constructorType, possibleType)) {
                if (checkNaN(variable, possibleType)) {
                    return String(variable);
                }
                return possibleType.toLowerCase();
            }
        }
        return "object";
    } else {
        return TYPE;
    }
}

function initSwiper() {
    Cash(".swiper-container").each(function() {
        //console.log(this);
        let slider = this;
        let nummberOfSlides = Cash(slider)
            .children()
            .children(".swiper-slide").length;

        if (nummberOfSlides) {
            let settings = {
                init: false
            };

            // Get the settings from CSS class
            Cash(slider.classList).each(function() {
                if (doesInclude(this, "--") && startWith(this, "swiper-")) {
                    let split = this.replace("swiper-", "").split("--");
                    let key = camelCase(split.shift());
                    settings[key] = convertFromString(split[0]);
                }
            });

            // Get aditional settings from data-settings
            let data = Cash(slider).data("settings");
            if (data) {
                Cash.extend(settings, data);
            }

            if (settings.init) {
                // Get parameter from existing slider
                let params = slider.swiper.originalParams;
                // Destroy existing slider
                slider.swiper.destroy();
                // Re-build slider
                new Swiper(slider, params);
            } else {
                if (
                    settings.type &&
                    getType(type[settings.type]) === "function"
                ) {
                    type[settings.type](slider, settings, nummberOfSlides);
                } else {
                    settings = mergeSettings({
                        source: settings,
                        nummberOfSlides
                    });
                    new Swiper(slider, settings);
                }
            }
        }
    });
}

export { initSwiper };
